import { TransferablePatientInfoResponse } from "@/Common/Api/ExternalCommunications/Dto/TransferablePatientInfoResponse";
import { AppointmentContactChannel } from "@/Common/Models/Appointments/AppointmentContactChannel";
import { IImportablePatient } from "@/Common/Models/Patient/IPatient";
import { IPatientCreationModel } from "@/Common/Models/Patient/UI/IPatientCreationModel";

class AppointmentPatientSnapshot {
    public Id: string;
    public ThirdPartyPatientId: string;
    public FirstName: string;
    public PreferredName: string;
    public LastName: string;
    public Gender: number;
    public Email: string;
    public DateOfBirth: Date;
    public Locale: number;
    public CreatedBy: string;
    public StreetAddress: string;
    public City: string;
    public PortalCode: string;
    public IsoProvinceCode: string;
    public HealthCardNumber: string;
    public HealthCardExpiry: Date;
    public LastModified: Date;
    public ContactData: AppointmentSnapshotContact[];
}

class ImportableAppointmentPatientSnapshot extends AppointmentPatientSnapshot implements IImportablePatient {
    public ClientTag: string;

    public get PatientId(): string {
        return this.ThirdPartyPatientId;
    }

    public get NAM(): string {
        return this.HealthCardNumber;
    }

    public isInternal(): boolean {
        return false; // TODO when implementing feature to import data from patient snapshot
    }

    public toTransferable(): TransferablePatientInfoResponse {
        return null; // TODO when implementing feature to import data from patient snapshot
    }

    public toPatientCreationModel(): IPatientCreationModel {
        return null; // TODO when implementing feature to import data from patient snapshot
    }
}

class AppointmentSnapshotContact {
    public Action: AppointmentContactChannel;
    public Value: string;
    public IsPreferred: boolean;
}

export { AppointmentPatientSnapshot, AppointmentSnapshotContact, ImportableAppointmentPatientSnapshot };
